import { Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ScenarioComparisonService } from './scenario-comparison.service';

declare var Highcharts: any;
declare var window: any;
Highcharts.setOptions({
  colors: ['#2D8B93', '#FF9836', '#5AD767', '#EB6620', '#5648FB', '#18F3CC', '#FF9655', '#FFF263', '#6AF9C4']
});

@Component({
    selector: 'app-scenario-comparison',
    templateUrl: './scenario-comparison.component.html',
    styleUrls: ['./scenario-comparison.component.scss'],
    standalone: false
})

export class ScenarioComparisonComponent implements OnInit {

  pageTitle: string = 'scenario comparison';
  isLoading: boolean = false;
  loaderSelector = '';
  @ViewChild('addScenarioRef')
  addScenarioRef: ElementRef<any>;

  @ViewChild("filterModal")
  filterModalRef: ElementRef<any>;

  @ViewChild('ndcListModal') 
  ndcListModal: any;

  @ViewChild('chartContainer')
  chartContainer: ElementRef<any>;
  chartOptions = {};

  isPopupVisible = false;
  showDiv = false;
  selectedCompetitorIndex = 0;
  selectedCustomerindex = 0;
  selectedFinancialindex = 0;
  selectedContractIndex = 0;
  isProductSelectAllChecked : boolean = true;
  isCustomerSelectAllChecked : boolean = true;
  isCompetitorSelectAllChecked : boolean = true;
  // decimalFormat: string = '1.0-1';  // default to 1 decimal
  contractDecimalFormat: string = '1.1-1';
  customerDecimalFormat: string = '1.1-1';
  competitorDecimalFormat: string = '1.1-1';
  contractDetailsDecimalFormat: string = '1.1-1';


  povCommonDdbSummary: any = {
    timeCategory: {
      selected: "Total Contract Period",
      options: ["Total Contract Period","Calendar Year"],
    },
  };
  calenderYears: any = {
    timeCategory: {
      selected: "",
      options: [],
    },
  };
  TimePerioddropdownVisible: boolean = true;
  selectedyear: string ;
  parentMetrics: any = [];
  ndcMap: any[] = []; // API response
  selectedParent: string | null = null; // Dropdown selection
  ndcParentList: string[] = []; // All unique NDC_PARENT values from all scenarios

  rawDataForComparison: any = {};
  paginationOptions: { itemsCount: number, pageSize: number, currentPage: number, maxDisplayPages: number } = {
    itemsCount: 10,
    pageSize: 5,
    currentPage: 1,
    maxDisplayPages: 5
  }
  scenarioListForComparison = [];
  scenariosToCompare = [];
  comparisonOutputGrid = [];
  financialData = [];
  compPOVData = [];
  customerPOVData = [];
  contractDetailsData = [];
  compProdList = [];
  customerProdList = [];
  contractProdList = [];
  brandList = [];
  ChannelList = [];
  productList = [];
  breakevenData: any[] = [];
  selectedBreakevenProductName: string = '';
  selectedBreakevenindex: number = 0;
  breakevenProdList: any[] = [];
  selectedContractFinancialMultiplier: number = 1;
  selectedMultiplier: number = 1;
  selectedCusPovMultiplier: number = 1;
  selectedContractDetailsMultiplier: number = 1;
  selectedBrandName = '';
  selectedChannel = '';
  selectedProductName = '';
  selectedFinancialProductName = '';
  selectedCompetitorProductName = '';
  selectedCustomerProductName = '';
  selectedContractProductName = '';
  searchComparisonScenarios = '';
  sortColumnForParentTable = 'DateModified';
  sortOrderForParentTable = true;   //false: will sort in ascending , true: will sort in descending
  counterForCheckedScenariosCount = 0;
  counterForCheckedScenariosCountSave = 0;
  anchorScenarioID = 0;
  startIndex = 0;
  endIndex = 0;
  previousStartIndex = 0;
  previousEndIndex = 0;
  showComparisonOutput = false;
  gridType: string = "";
  copyToExcelString: string;
  customCopyFlag: boolean;
  maxCheckedScenarios: number;
  showAnchor: boolean;
  anchoredScenariosCnt: number = 0;
  maxAnchor : number
  maxCheckedLimit: number = 5; // Maximum allowed selections
  checkedCount: number = 0;
  scenariosCheckedForComparison = 0;     // Tracks the number of checkboxes selected
  tempFinancialData = [];
  originalFinancialData = [];
  tempCompPOVData = [];
  originalCompPOVData = [];
  tempCustomerPOVData = [];
  originalCustomerPOVData = [];
  pcgcData: any;
  searchTextFinancial: string = "";
  searchTextCustomer: string = "";
  searchTextCompetitor: string = "";
  isPCGCSelected :boolean = false;
  isPCGCSelectedcheck :boolean = false;
  subFinancialConfigurationDiscountSummary = {};
  subContractFinancialConfigurationDiscountSummary = {};
  subContractDetailsConfigurationDiscountSummary = {};
  subCustomerPOVConfigurationDiscountSummary = {};
  oldFinIdx : number;
  oldCustIdx : number;
  oldCompIdx : number;
  oldContractIdx : number;
  resources : any;
  resourcesFields : any;
  filterSummaryHeaderName : string = "Leadership";
  searchArr = [];

  constructor(private appService: AppService, private scenarioComparisonService: ScenarioComparisonService, private router: Router) {
    this.resources = this.appService.resources;
    this.resourcesFields = this.appService.resourceFields;
    document.addEventListener('copy', (e) => {
      if (this.customCopyFlag) {
        this.copyToExcelString = this.getCopiedData();
        this.customCopyFlag = false;
        e.clipboardData.setData('text/plain', this.copyToExcelString);
        e.preventDefault();
      }
    });
  }

  handleError(message: string = 'Something went wrong. Please try again.') {
    this.appService.showAlert = {
      show: true,
      message: message,
      messageType: 'error',
      timer: null
    };
  }

  // handleCheckboxChange(event: any, scenario: any, checkboxType: 'deal' | 'noDeal' | 'anchor'): void {
  //   const checkbox = event.target as HTMLInputElement;
  //   const isChecking = checkbox.checked;

  //   if (isChecking) {
  //     if (!this.canSelectCheckbox(checkboxType)) {
  //       event.preventDefault();
  //       this.showMaxLimitAlert(checkboxType);
  //       return;
  //     }
  //     if(checkboxType == 'anchor'){
  //       this.updateCounters(checkboxType, true);
  //       scenario[checkboxType] = true;

  //       this.updateCounters('deal', true);
  //       scenario['deal'] = true;

  //       this.updateCounters('noDeal', true);
  //       scenario['noDeal'] = true;
  //     }
  //     this.updateCounters(checkboxType, true);
  //     scenario[checkboxType] = true;
  //   } else {
  //     this.updateCounters(checkboxType, false);
  //     scenario[checkboxType] = false;
  //   }
  // }

  // private canSelectCheckbox(checkboxType: 'deal' | 'noDeal' | 'anchor'): boolean {
  //   if (checkboxType === 'anchor') {
  //     return this.anchoredScenariosCnt <= this.maxAnchor;
  //   }
  //   return this.checkedCount < this.maxCheckedLimit;
  // }

  // private updateCounters(checkboxType: 'deal' | 'noDeal' | 'anchor', isIncrementing: boolean): void {
  //   if (checkboxType === 'anchor') {
  //     this.anchoredScenariosCnt += isIncrementing ? 1 : -1;
  //   } else {
  //     this.checkedCount += isIncrementing ? 1 : -1;
  //   }
  // }

  // private showMaxLimitAlert(checkboxType: 'deal' | 'noDeal' | 'anchor'): void {
  //   const limit = checkboxType === 'anchor' ? this.maxAnchor : this.maxCheckedLimit;
  //   alert(`You can only select a maximum of ${limit} ${checkboxType} checkbox${limit > 1 ? 'es' : ''}.`);
  // }
  handleCheckboxChange(event: any, scenario: any, checkboxType: 'deal' | 'noDeal' | 'anchor'): void {
    const checkbox = event.target as HTMLInputElement;
    const isChecking = checkbox.checked;

    if (isChecking) {
      if (!this.canSelectCheckbox(checkboxType)) {
        event.preventDefault();
        checkbox.checked = false;
        scenario[checkboxType] = false;
        this.showMaxLimitAlert(checkboxType);
        return;
      }

      if (checkboxType === 'anchor') {
        this.updateCounters(checkboxType, true);
        scenario.anchor = true;

        // Only set deal and noDeal if they weren't already set
        if (!scenario.deal) {
          this.updateCounters('deal', true);
          scenario.deal = true;
        }
        if (!scenario.noDeal) {
          this.updateCounters('noDeal', true);
          scenario.noDeal = true;
        }
      } else {
        this.updateCounters(checkboxType, true);
        scenario[checkboxType] = true;
      }
    } else {
      if (checkboxType === 'anchor') {
        this.updateCounters(checkboxType, false);
        scenario.anchor = false;

        // Only unset deal and noDeal if they were set by anchor
        if (scenario.deal) {
          this.updateCounters('deal', false);
          scenario.deal = false;
        }
        if (scenario.noDeal) {
          this.updateCounters('noDeal', false);
          scenario.noDeal = false;
        }
      } else {
        this.updateCounters(checkboxType, false);
        scenario[checkboxType] = false;
        if(!scenario.deal && !scenario.noDeal && scenario.anchor){
          this.updateCounters('anchor',false);
          scenario.anchor = false;
        }

      }
    }
  }

  private canSelectCheckbox(checkboxType: 'deal' | 'noDeal' | 'anchor'): boolean {
    if (checkboxType === 'anchor') {
      return this.anchoredScenariosCnt < this.maxAnchor;
    }
    return this.checkedCount < this.maxCheckedLimit;
  }

  private updateCounters(checkboxType: 'deal' | 'noDeal' | 'anchor', isIncrementing: boolean): void {
    if (checkboxType === 'anchor') {
      this.anchoredScenariosCnt += isIncrementing ? 1 : -1;
    } else {
      this.checkedCount += isIncrementing ? 1 : -1;
    }
  }

  private showMaxLimitAlert(checkboxType: 'deal' | 'noDeal' | 'anchor'): void {
    const limit = checkboxType === 'anchor' ? this.maxAnchor : this.maxCheckedLimit;
    alert(`You can only select a maximum of ${limit} ${checkboxType} checkbox${limit > 1 ? 'es' : ''}.`);
  }

  pageChange($event) {
    this.paginationOptions.currentPage = $event.detail.newPage;
    var newValue = $event.detail.newPage;
    var pageSize = this.paginationOptions.pageSize;
    var startIndex = pageSize * (newValue - 1);
    var endIndex = startIndex + pageSize - 1;
    var fetchFilteredData = false;
    if (this.startIndex != undefined)
      fetchFilteredData = true;
    this.previousStartIndex = this.startIndex;
    this.previousEndIndex = this.endIndex;
    this.startIndex = startIndex;
    this.endIndex = endIndex;
    if (fetchFilteredData)
      this.getFilteredScenarios('pagination');

  }

  ngOnInit(): void {
    this.isLoading = true;
    this.filterSummaryHeaderName = this.resourcesFields.ScenarioComparisonFilterSummary.text
    this.loaderSelector = this.appService.loaderColors.pine_green;
    this.scenarioComparisonService.getAllScenariosForComparison().subscribe(data => {
      this.openScenarioComparison(data);
      this.isLoading = false;
      // this.showAnchor = this.determineCondition();
      this.showAnchor = false;
      if(!localStorage.getItem("showAnchor")){
        localStorage.setItem("showAnchor",JSON.stringify(this.showAnchor));
      }else{
        this.showAnchor = JSON.parse(localStorage.getItem("showAnchor"))
      }
      this.showDiv = this.showAnchor;
      this.setMaxCheckedScenarios();
    }, error => {
      this.handleError('Failed to load scenarios for comparison.');
    });
  }

  determineCondition(): boolean {
    return this.appService.resources.ScenarioComparison.Visible == 'N';
  }
  isCheckboxDisabled(scenario: any): boolean {
    return !scenario.anchor && this.anchoredScenariosCnt >= this.maxAnchor;
  }
  setMaxCheckedScenarios() {
    if (this.showAnchor) {
      this.maxCheckedScenarios = 4;
      this.maxCheckedLimit = 4;
      this.maxAnchor = 1;
    }
    else {
      this.maxCheckedScenarios = 5;
      this.maxAnchor = 1;
    }
    return;
  }

  openFilterModal() {
    this.filterModalRef.nativeElement.showModal();
  }

  selectPCGCMetrics(){
    this.isPCGCSelected = !this.isPCGCSelected;
    if(this.isPCGCSelected){
      this.tempFinancialData[this.selectedFinancialindex]?.financialData.forEach((finMtr)=>{
        const isPresent = this.pcgcData.financial_screen.includes(finMtr.lineItem);
        isPresent ? finMtr.isSelected = true : finMtr.isSelected = false;
      })
      this.tempCustomerPOVData[this.selectedCustomerindex]?.data.forEach((custMtr)=>{
        const isPresent = this.pcgcData.customer_screen.includes(custMtr.lineItem);
        isPresent ? custMtr.isSelected = true : custMtr.isSelected = false;
      })
      
      this.tempCompPOVData[this.selectedCompetitorIndex]?.data.forEach((compMtr)=>{
        const isPresent = this.pcgcData.competitor_screen?.includes(compMtr.lineItem);
        isPresent ? compMtr.isSelected = true : compMtr.isSelected = false;
      })

      this.selectPCGCParentMetricsCalc();

      this.isProductSelectAllChecked = this.tempFinancialData[this.selectedFinancialindex]?.financialData?.every((element: any) => element.isSelected === true );
      this.isCustomerSelectAllChecked = this.tempCustomerPOVData[this.selectedCustomerindex]?.data?.every((element: any) => element.isSelected === true );
      this.isCompetitorSelectAllChecked = this.tempCompPOVData[this.selectedCompetitorIndex]?.data?.every((element: any) => element.isSelected === true );
    }else{
      this.resetFilters();
    }
  }
  selectPCGCParentMetricsCalc(){        
    for (let i = 0; i < this.tempFinancialData.length; i++) {
      for (let j = 0; j < this.tempFinancialData[i].financialData.length; j++) {
        let item = this.tempFinancialData[i].financialData[j];
        if(this.parentMetrics.includes(item.lineItem)){
          if(this.pcgcData.financial_screen.includes(item.lineItem)){
            for(let k = 0; k < item.data.length; k++) {
              if (!isNaN(item.data[k])) {
                item.data[k] = this.originalFinancialData[i].financialData[j].data[k];
              }
            }
            for (let y = 0; y < item.yearlyDataView.length; y++) {
              for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
                if (!isNaN(item.yearlyDataView[y].data[z])) {
                  item.yearlyDataView[y].data[z] = this.originalFinancialData[i].financialData[j].yearlyDataView[y].data[z]; 
                }
              }
            }
          }else{
            for(let k = 0; k < item.data.length; k++) {
              if (!isNaN(item.data[k])) {
                item.data[k] = 0;
              }
            }
            for (let y = 0; y < item.yearlyDataView.length; y++) {
              for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
                if (!isNaN(item.yearlyDataView[y].data[z])) {
                  item.yearlyDataView[y].data[z] = 0; 
                }
              }
            }
          }
        }
      }
    }
    for (let i = 0; i < this.tempCustomerPOVData.length; i++) {
      for (let j = 0; j < this.tempCustomerPOVData[i].data.length; j++) {
        let item = this.tempCustomerPOVData[i].data[j];
        if(this.parentMetrics.includes(item.lineItem)){
          if(this.pcgcData.customer_screen.includes(item.lineItem)){
            for(let k = 0; k < item.data.length; k++) {
              if (!isNaN(item.data[k])) {
                item.data[k] = this.originalCustomerPOVData[i].data[j].data[k];
              }
            }
            for (let y = 0; y < item.yearlyDataView.length; y++) {
              for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
                if (!isNaN(item.yearlyDataView[y].data[z])) {
                  item.yearlyDataView[y].data[z] = this.originalCustomerPOVData[i].data[j].yearlyDataView[y].data[z]; 
                }
              }
            }
          }else{
            for(let k = 0; k < item.data.length; k++) {
              if (!isNaN(item.data[k])) {
                item.data[k] = 0;
              }
            }
            for (let y = 0; y < item.yearlyDataView.length; y++) {
              for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
                if (!isNaN(item.yearlyDataView[y].data[z])) {
                  item.yearlyDataView[y].data[z] = 0; 
                }
              }
            }
          }
        }
      }
    }
    for (let i = 0; i < this.tempCompPOVData.length; i++) {
      for (let j = 0; j < this.tempCompPOVData[i].data.length; j++) {
        let item = this.tempCompPOVData[i].data[j];
        if(this.parentMetrics.includes(item.lineItem)){
            for(let k = 0; k < item.data.length; k++) {
              if (!isNaN(item.data[k])) {
                item.data[k] = 0;
              }
            }
            for (let y = 0; y < item.yearlyDataView.length; y++) {
              for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
                if (!isNaN(item.yearlyDataView[y].data[z])) {
                  item.yearlyDataView[y].data[z] = 0; 
                }
              }
            }
        }
      }
    }
  }
  selectAllMetrices(event,func,tabData,searchTxt?){
    if(searchTxt?.length){
      func.forEach((item: any) =>{
        if(item.Item_Text.toLowerCase().includes(searchTxt)){
          item.isSelected = event.target.checked;
        }
      });
    }else{
      func.forEach((item: any) => item.isSelected = event.target.checked);
    }
    if(event.target.checked){
      if(tabData=='tempFinancialData')this.tempFinancialData=JSON.parse(JSON.stringify(this.originalFinancialData));
      if(tabData=='tempCustomerPOVData')this.tempCustomerPOVData=JSON.parse(JSON.stringify(this.originalCustomerPOVData));
      if(tabData=='tempCompPOVData')this.tempCompPOVData=JSON.parse(JSON.stringify(this.originalCompPOVData));
    }
  }

  resetFilters() {
    // Reset logic for all sections
    this.tempFinancialData[this.selectedFinancialindex].financialData.forEach((item : any) => (item.isSelected = true));
    this.tempCustomerPOVData[this.selectedCustomerindex].data.forEach((item : any) => (item.isSelected = true));
    this.tempCompPOVData[this.selectedCompetitorIndex].data.forEach((item : any) => (item.isSelected = true));
    this.isProductSelectAllChecked = true;
    this.isCustomerSelectAllChecked = true;
    this.isCompetitorSelectAllChecked = true;
    this.searchTextFinancial = "";
    this.searchTextCustomer = "";
    this.searchTextCompetitor = "";
    this.isPCGCSelected = false;
    this.tempFinancialData=JSON.parse(JSON.stringify(this.originalFinancialData));
    this.financialData = JSON.parse(JSON.stringify(this.originalFinancialData));
    this.tempCustomerPOVData=JSON.parse(JSON.stringify(this.originalCustomerPOVData));
    this.customerPOVData=JSON.parse(JSON.stringify(this.originalCustomerPOVData));
    this.tempCompPOVData=JSON.parse(JSON.stringify(this.originalCompPOVData));
    this.compPOVData=JSON.parse(JSON.stringify(this.originalCompPOVData));
  }

  openFilter() {
    this.filterModalRef.nativeElement.showModal();
    this.tempFinancialData = JSON.parse(JSON.stringify(this.financialData));
    this.tempCustomerPOVData = JSON.parse(JSON.stringify(this.customerPOVData));
    this.tempCompPOVData = JSON.parse(JSON.stringify(this.compPOVData));
    this.isProductSelectAllChecked = this.tempFinancialData[this.selectedFinancialindex]?.financialData?.every((element : any) => element.isSelected === true );
    this.isCustomerSelectAllChecked = this.tempCustomerPOVData[this.selectedCustomerindex]?.data?.every((element : any) => element.isSelected === true );
    this.isCompetitorSelectAllChecked = this.tempCompPOVData[this.selectedCompetitorIndex]?.data?.every((element : any) => element.isSelected === true );
  }

  closeFilter(){
    this.filterModalRef.nativeElement.close()
    this.isPCGCSelected = false;
    if(this.isPCGCSelectedcheck == true){
      this.isPCGCSelected = true;
    }
  }
  openNdcListModal(): void {
        this.ndcListModal.nativeElement.showModal();
  }
  closeNdcListModal(): void {
    if (this.ndcListModal?.nativeElement?.close) {
      this.ndcListModal.nativeElement.close();
    }
  }

  applyFilters() {
    this.financialData = JSON.parse(JSON.stringify(this.tempFinancialData));
    this.customerPOVData = JSON.parse(JSON.stringify(this.tempCustomerPOVData));
    this.compPOVData = JSON.parse(JSON.stringify(this.tempCompPOVData));
    this.isPCGCSelectedcheck = this.isPCGCSelected ;
    this.filterModalRef.nativeElement.close();
  }


  checkMetrics(event: any ,metric : any,func: any,tab: any){
    if(metric.parentMetric === null){
      this.parentMetricsCalc(event, metric,tab);
      func.forEach((item: any)=> {
        if(metric.lineItem === item.parentMetric){
          item.isSelected = event.target.checked;
        }
      })
    }
    if(this.isPCGCSelected){
      this.isPCGCSelected = false;
    }
    this.isProductSelectAllChecked = this.tempFinancialData[this.selectedFinancialindex]?.financialData?.every((element : any) => element.isSelected === true );
    this.isCustomerSelectAllChecked = this.tempCustomerPOVData[this.selectedCustomerindex]?.data?.every((element : any) => element.isSelected === true );
    this.isCompetitorSelectAllChecked = this.tempCompPOVData[this.selectedCompetitorIndex]?.data?.every((element : any) => element.isSelected === true );
  }
  parentMetricsCalc(event: any ,metric : any,tab: any){
    let tempData, originalData;
    if(tab === 'tempFinancialData'){
      tempData = this.tempFinancialData;
      originalData = this.originalFinancialData;
    }else if(tab === 'tempCustomerPOVData'){
      tempData = this.tempCustomerPOVData;
      originalData = this.originalCustomerPOVData;
    }else if(tab === 'tempCompPOVData'){
      tempData = this.tempCompPOVData;
      originalData = this.originalCompPOVData;
    }
    for (let i = 0; i < tempData.length; i++) {
      let productItems,originalItems;
      if(tab === 'tempFinancialData'){
        productItems = tempData[i].financialData;
        originalItems = originalData[i].financialData;
      }else{
        productItems = tempData[i].data;
        originalItems = originalData[i].data;
      }
      for (let j = 0; j < productItems.length; j++) {
        let item = productItems[j];
        if( item.lineItem === metric.lineItem) {
          if(event.target.checked){
            for(let k = 0; k < item.data.length; k++) {
              if (!isNaN(item.data[k])) {
                item.data[k] = originalItems[j].data[k];
              }
            }
            for (let y = 0; y < item.yearlyDataView.length; y++) {
              for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
                if (!isNaN(item.yearlyDataView[y].data[z])) {
                  item.yearlyDataView[y].data[z] = originalItems[j].yearlyDataView[y].data[z]; 
                }
              }
            }
          }else{
            for(let k = 0; k < item.data.length; k++) {
              if (!isNaN(item.data[k])) {
                item.data[k] = 0;
              }
            }
            for (let y = 0; y < item.yearlyDataView.length; y++) {
              for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
                if (!isNaN(item.yearlyDataView[y].data[z])) {
                  item.yearlyDataView[y].data[z] = 0; 
                }
              }
            }
          }
        }
      }
    }
  }
  checkSubMetrics(event: any ,metric : any,func: any, tab: any){
      let parentMetricName= metric.parentMetric;
      let lineItemName= metric.lineItem;
      let parentMetric : any;
      func.forEach((item: any)=> {
        if(item.lineItem === metric.parentMetric){
          parentMetric = item;
      }
    })
if (tab === 'tempFinancialData') {
  for (let i = 0; i < this.tempFinancialData.length; i++) {
    for (let j = 0; j < this.tempFinancialData[i].financialData.length; j++) {
      let item = this.tempFinancialData[i].financialData[j];
      if (item.lineItem === parentMetricName) {
        let childMetric = this.tempFinancialData[i].financialData.find((child: any) => child.lineItem === lineItemName);
        for (let k = 0; k < item.data.length; k++) {
          if (!isNaN(item.data[k]) && !isNaN(childMetric.data[k])) {
            item.data[k] = event.target.checked
              ? item.data[k] + childMetric.data[k]
              : item.data[k] - childMetric.data[k];
          }
        }
        for (let y = 0; y < item.yearlyDataView.length; y++) {
          for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
            if (!isNaN(item.yearlyDataView[y].data[z]) && !isNaN(childMetric.yearlyDataView[y].data[z])) {
              item.yearlyDataView[y].data[z] = event.target.checked
                ? item.yearlyDataView[y].data[z] + childMetric.yearlyDataView[y].data[z]
                : item.yearlyDataView[y].data[z] - childMetric.yearlyDataView[y].data[z];
            }
          }
        }
      }
    }
  }
} else if (tab === 'tempCustomerPOVData') {
  for (let i = 0; i < this.tempCustomerPOVData.length; i++) {
    for (let j = 0; j < this.tempCustomerPOVData[i].data.length; j++) {
      let item = this.tempCustomerPOVData[i].data[j];
      if (item.lineItem === parentMetricName) {
        let childMetric = this.tempCustomerPOVData[i].data.find((child: any) => child.lineItem === lineItemName);
        for (let k = 0; k < item.data.length; k++) {
          if (!isNaN(item.data[k]) && !isNaN(childMetric.data[k])) {
            if(childMetric.lineItem==='FederalReinsurance'){
              item.data[k] = event.target.checked
                ? item.data[k] - childMetric.data[k]
                : item.data[k] + childMetric.data[k];
            }else{
              item.data[k] = event.target.checked
                ? item.data[k] + childMetric.data[k]
                : item.data[k] - childMetric.data[k];
            }
          }
        }
        for (let y = 0; y < item.yearlyDataView.length; y++) {
          for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
            if (!isNaN(item.yearlyDataView[y].data[z]) && !isNaN(childMetric.yearlyDataView[y].data[z])) {
              if(childMetric.lineItem==='FederalReinsurance'){
                item.yearlyDataView[y].data[z] = event.target.checked
                  ? item.yearlyDataView[y].data[z] - childMetric.yearlyDataView[y].data[z]
                  : item.yearlyDataView[y].data[z] + childMetric.yearlyDataView[y].data[z]; 
              }else{
                item.yearlyDataView[y].data[z] = event.target.checked
                  ? item.yearlyDataView[y].data[z] + childMetric.yearlyDataView[y].data[z]
                  : item.yearlyDataView[y].data[z] - childMetric.yearlyDataView[y].data[z];  
              }
            }
          }
        }
      }
    }
  }
} else if (tab === 'tempCompPOVData') {
  for (let i = 0; i < this.tempCompPOVData.length; i++) {
    for (let j = 0; j < this.tempCompPOVData[i].data.length; j++) {
      let item = this.tempCompPOVData[i].data[j];
      if (item.lineItem === parentMetricName) {
        let childMetric = this.tempCompPOVData[i].data.find((child: any) => child.lineItem === lineItemName);
        for (let k = 0; k < item.data.length; k++) {
          if (!isNaN(item.data[k]) && !isNaN(childMetric.data[k])) {
            item.data[k] = event.target.checked
              ? item.data[k] + childMetric.data[k]
              : item.data[k] - childMetric.data[k];
          }
        }
        for (let y = 0; y < item.yearlyDataView.length; y++) {
          for (let z = 0; z < item.yearlyDataView[y].data.length; z++) {
            if (!isNaN(item.yearlyDataView[y].data[z]) && !isNaN(childMetric.yearlyDataView[y].data[z])) {
              item.yearlyDataView[y].data[z] = event.target.checked
                ? item.yearlyDataView[y].data[z] + childMetric.yearlyDataView[y].data[z]
                : item.yearlyDataView[y].data[z] - childMetric.yearlyDataView[y].data[z];
            }
          }
        }
      }
    }
  }
}

    if(this.isPCGCSelected){
      this.isPCGCSelected = false;
    }
    this.isProductSelectAllChecked = this.tempFinancialData[this.selectedFinancialindex]?.financialData?.every((element : any) => element.isSelected === true );
    this.isCustomerSelectAllChecked = this.tempCustomerPOVData[this.selectedCustomerindex]?.data?.every((element : any) => element.isSelected === true );
    this.isCompetitorSelectAllChecked = this.tempCompPOVData[this.selectedCompetitorIndex]?.data?.every((element : any) => element.isSelected === true );
    parentMetric.isSelected = func.filter((item: any) => item.parentMetric === parentMetric.lineItem).some((item: any) => item.isSelected === true);
  }

  checkSubMetricVisiblity(metric : any,scenario){
    return scenario.find((item: any) => item.lineItem === metric)?.isSelected;
  }
  //called when scenario comparison tab is clicked
  openScenarioComparison = function (data) {

    this.paginationOptions.itemsCount = data.itemsCount;
    this.paginationOptions.pageSize = 5;
    this.paginationOptions.currentPage = 1;
    this.brandList = data.allBrands;
    this.ChannelList = data.allChannels;
    this.selectedBrandName = this.brandList[0];
    this.selectedChannel = this.ChannelList[0];

  }

  addScenarioForComparison = function () {
    this.counterForCheckedScenariosCount = this.counterForCheckedScenariosCountSave;
    this.searchComparisonScenarios = '';
    this.getFilteredScenarios('addScenario');
    this.anchoredScenariosCnt = 0;
    this.addScenarioRef.nativeElement.showModal();

  }

  isModalLoading: boolean = false;
  private searchTimeout: any; 

  //simple debounced search method
  onSearchInput() {
    // Clear existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    
    // Set new timeout - call API after 500ms of no typing
    this.searchTimeout = setTimeout(() => {
      this.getFilteredScenarios('search');
    }, 500);
  }

  getFilteredScenarios = function (filterType) {

    // if (filterType == "search" && this.searchComparisonScenarios.length > 0 && this.searchComparisonScenarios.length <= 3)
    //   return;

    var params = {
      searchText: this.searchComparisonScenarios || '',
      filters: {
        BrandName: this.selectedBrandName || '',
        Channel: this.selectedChannel || ''
      },
      sort: {
        columnName: this.sortColumnForParentTable || null,
        order: this.sortOrderForParentTable || null
      },
      pagination: {
        startIndex: this.startIndex || 0,
        endIndex: this.endIndex || 5,
        previousStartIndex: this.previousStartIndex || 0,
        previousEndIndex: this.previousEndIndex || 5
      },
      filterType: filterType || '',
      displayData: this.scenarioListForComparison || []

    }
    this.isModalLoading = true;
    this.scenarioComparisonService.getFilteredScenarios(params).subscribe(res => {
      this.scenarioListForComparison = res.displayScenarios;
      if(this.searchArr.length > 0){
        this.scenarioListForComparison.forEach((el : any) => {
          const isPresentArr = this.searchArr.find((el2 : any)=> el2.ScenarioID === el.ScenarioID);
          if(isPresentArr) el.checkedForComparison = true;
        });
      }
      this.paginationOptions.itemsCount = res.scenarioCount;
      this.previousStartIndex = this.startIndex = res.startIndex;
      this.previousEndIndex = this.endIndex = res.endIndex;
      this.isModalLoading = false;
    }, error => {
      this.handleError('Failed to load filtered scenarios for comparison.');
    });

  }
  counterForCheckedScenarios = function (scenario) {
    if(this.counterForCheckedScenariosCount < 0) this.counterForCheckedScenariosCount = 0;
    if (scenario['checkedForComparison']) {
      this.counterForCheckedScenariosCount += 1;
      this.searchArr.push(scenario);
    } else {
      this.counterForCheckedScenariosCount -= 1;
      this.searchArr = this.searchArr.filter((item : any) => item.ScenarioID !== scenario.ScenarioID);
    }
  }

  resetSelectedScenarioCount = function () {
    var filteredScenarios = this.scenarioListForComparison.filter((obj) => { return (obj.BrandName == this.selectedBrandName) && (obj.Channel == this.selectedChannel) });
    this.counterForCheckedScenariosCount = 0;
    this.searchArr = [];
    for (let i = 0; i < filteredScenarios.length; ++i) {
      if (filteredScenarios[i].checkedForComparison) {
        this.counterForCheckedScenariosCount += 1;
      }
    }
  }

  confirmScenarioComparison = function () {

    this.counterForCheckedScenariosCountSave = this.counterForCheckedScenariosCount;
    this.showComparisonOutput = false;

    const params = {
      displayData: this.searchArr,
      // displayData: this.scenarioListForComparison,
      pagination: {
        previousStartIndex: this.previousStartIndex || 0,
        previousEndIndex: this.previousEndIndex || 5
      }
    }
    this.isLoading = true;
    this.scenarioComparisonService.confirmScenariosForComparison(params).subscribe(data => {
      this.scenariosToCompare = data;
      this.checkedCount = 0;
      this.addScenarioRef.nativeElement.close();
      this.isLoading = false;
    }, error => {
      this.handleError('Failed to confirm scenarios for comparison.');
    });

  }

  removeScenarioFromComparison = function (scenarioId) {
    let tempScenariosToCompare = JSON.parse(JSON.stringify(this.scenariosToCompare));
    // this.scenarioListForComparison.find((scenario) => scenario.ScenarioID === scenarioId).checkedForComparison = false;
    this.scenariosToCompare = [];
    for (let i = 0; i < tempScenariosToCompare.length; ++i) {
      if (tempScenariosToCompare[i].ScenarioID != scenarioId) {
        this.scenariosToCompare.push(tempScenariosToCompare[i]);
      } else {
        if (tempScenariosToCompare[i].deal === true) {
          tempScenariosToCompare[i].deal = false;
          this.checkedCount--;
        }
        if (tempScenariosToCompare[i].noDeal === true) {
          tempScenariosToCompare[i].noDeal = false;
          this.checkedCount--;
        }
        if (tempScenariosToCompare[i].anchor === true) {
          tempScenariosToCompare[i].anchor = false;
          this.anchoredScenariosCnt--;
        }

      }
    }
  }

  anchorScenarioChecked = function (rowIndex) {
    if (this.scenariosToCompare[rowIndex].anchor == true) {
      for (let idx = 0; idx < this.scenariosToCompare.length; ++idx) {
        if (idx != rowIndex) {
          this.scenariosToCompare[idx].anchor = false;
        }
      }
    }
  }

  checkCustomerFinancialSubProductInputTabDiscountSummary(SelectedFinancialPrdIndex, index) {
    let flag = 0
    for (let i = index + 1; i < this.customerPOVData[SelectedFinancialPrdIndex]['data'].length; i++) {
      if (this.customerPOVData[SelectedFinancialPrdIndex]['data'][i]['Is_Submetric'] === 'Yes' && this.customerPOVData[SelectedFinancialPrdIndex]['data'][i]['isSelected'] === true) {
        flag = 1;
        if (!this.subCustomerPOVConfigurationDiscountSummary[SelectedFinancialPrdIndex]?.data?.[index]) {
          if (!this.subCustomerPOVConfigurationDiscountSummary[SelectedFinancialPrdIndex]) {
            this.subCustomerPOVConfigurationDiscountSummary[SelectedFinancialPrdIndex] = {
              data: {
                [index]: [this.customerPOVData[SelectedFinancialPrdIndex]['data'][i]]
              }
            }
          } else {
            this.subCustomerPOVConfigurationDiscountSummary[SelectedFinancialPrdIndex].data[index] = [this.customerPOVData[SelectedFinancialPrdIndex]['data'][i]]
          }
        }

        let isExists =
          this.subCustomerPOVConfigurationDiscountSummary[SelectedFinancialPrdIndex]['data'][index].some(item => item.lineItem == this.customerPOVData[SelectedFinancialPrdIndex]['data'][i].lineItem)
        if (!isExists) {
          this.subCustomerPOVConfigurationDiscountSummary[SelectedFinancialPrdIndex]['data'][index].push(this.customerPOVData[SelectedFinancialPrdIndex]['data'][i])
        }
        this.subCustomerPOVConfigurationDiscountSummary[SelectedFinancialPrdIndex]['data'][index].forEach(element => {
          if (element.lineItem == this.customerPOVData[SelectedFinancialPrdIndex]['data'][i].lineItem) {

            if (element && element.data) {
              element.data = this.customerPOVData[SelectedFinancialPrdIndex]['data'][i].data
            }
          }
        });

      } else if (this.customerPOVData[SelectedFinancialPrdIndex]['data'][i]['Is_Submetric'] === 'No' && this.customerPOVData[SelectedFinancialPrdIndex]['data'][i]['isSelected'] === true) {
        break;
      }
    }

    return flag === 1 ? true : false;
  }
  checkContractDetailsSubProductInputTabDiscountSummary(selectedIndex, index) {
  let flag = 0;
  for (let i = index + 1; i < this.contractDetailsData[selectedIndex]['data'].length; i++) {
    if (
      this.contractDetailsData[selectedIndex]['data'][i]['Is_Submetric'] === 'Yes' &&
      this.contractDetailsData[selectedIndex]['data'][i]['isSelected'] === true
    ) {
      flag = 1;
      if (!this.subContractDetailsConfigurationDiscountSummary[selectedIndex]?.data?.[index]) {
        if (!this.subContractDetailsConfigurationDiscountSummary[selectedIndex]) {
          this.subContractDetailsConfigurationDiscountSummary[selectedIndex] = {
            data: {
              [index]: [this.contractDetailsData[selectedIndex]['data'][i]]
            }
          };
        } else {
          this.subContractDetailsConfigurationDiscountSummary[selectedIndex].data[index] = [
            this.contractDetailsData[selectedIndex]['data'][i]
          ];
        }
      }
      let isExists =
        this.subContractDetailsConfigurationDiscountSummary[selectedIndex]['data'][index].some(
          item => item.lineItem == this.contractDetailsData[selectedIndex]['data'][i].lineItem
        );
      if (!isExists) {
        this.subContractDetailsConfigurationDiscountSummary[selectedIndex]['data'][index].push(
          this.contractDetailsData[selectedIndex]['data'][i]
        );
      }
      this.subContractDetailsConfigurationDiscountSummary[selectedIndex]['data'][index].forEach(element => {
        if (element.lineItem == this.contractDetailsData[selectedIndex]['data'][i].lineItem) {
          if (element && element.data) {
            element.data = this.contractDetailsData[selectedIndex]['data'][i].data;
          }
        }
      });
    } else if (
      this.contractDetailsData[selectedIndex]['data'][i]['Is_Submetric'] === 'No' &&
      this.contractDetailsData[selectedIndex]['data'][i]['isSelected'] === true
    ) {
      break;
    }
  }
  return flag === 1 ? true : false;
}
  checkFinancialSubProductInputTabDiscountSummary(SelectedFinancialPrdIndex, index) {
    let flag = 0
    for (let i = index + 1; i < this.financialData[SelectedFinancialPrdIndex]['financialData'].length; i++) {
      if (this.financialData[SelectedFinancialPrdIndex]['financialData'][i]['Is_Submetric'] === 'Yes' && this.financialData[SelectedFinancialPrdIndex]['financialData'][i]['isSelected'] === true) {
        flag = 1;
        if (!this.subContractFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]?.financialData?.[index]) {
          if (!this.subContractFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]) {
            this.subContractFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex] = {
              financialData: {
                [index]: [this.financialData[SelectedFinancialPrdIndex]['financialData'][i]]
              }
            }
          } else {
            this.subContractFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex].financialData[index] = [this.financialData[SelectedFinancialPrdIndex]['financialData'][i]]
          }
        }

        let isExists =
          this.subContractFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]['financialData'][index].some(item => item.lineItem == this.financialData[SelectedFinancialPrdIndex]['financialData'][i].lineItem)
        if (!isExists) {
          this.subContractFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]['financialData'][index].push(this.financialData[SelectedFinancialPrdIndex]['financialData'][i])
        }
        this.subContractFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]['financialData'][index].forEach(element => {
          if (element.lineItem == this.financialData[SelectedFinancialPrdIndex]['financialData'][i].lineItem) {

            if (element && element.data) {
              element.data = this.financialData[SelectedFinancialPrdIndex]['financialData'][i].data
            }
          }
        });

      } else if (this.financialData[SelectedFinancialPrdIndex]['financialData'][i]['Is_Submetric'] === 'No' && this.financialData[SelectedFinancialPrdIndex]['financialData'][i]['isSelected'] === true) {
        break;
      }
    }
    return flag === 1 ? true : false;
  }
  checkSubProductInputTabDiscountSummary(SelectedFinancialPrdIndex, index) {
    let flag = 0
    for (let i = index + 1; i < this.compPOVData[SelectedFinancialPrdIndex]['data'].length; i++) {
      if (this.compPOVData[SelectedFinancialPrdIndex]['data'][i]['Is_Submetric'] === 'Yes' && this.compPOVData[SelectedFinancialPrdIndex]['data'][i]['isSelected'] === true) {
        flag = 1;
        if (!this.subFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]?.data?.[index]) {
          if (!this.subFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]) {
            this.subFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex] = {
              data: {
                [index]: [this.compPOVData[SelectedFinancialPrdIndex]['data'][i]]
              }
            }
          } else {
            this.subFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex].data[index] = [this.compPOVData[SelectedFinancialPrdIndex]['data'][i]]
          }
        }

        let isExists =
          this.subFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]['data'][index].some(item => item.lineItem == this.compPOVData[SelectedFinancialPrdIndex]['data'][i].lineItem)
        if (!isExists) {
          this.subFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]['data'][index].push(this.compPOVData[SelectedFinancialPrdIndex]['data'][i])
        }
        this.subFinancialConfigurationDiscountSummary[SelectedFinancialPrdIndex]['data'][index].forEach(element => {
          if (element.lineItem == this.compPOVData[SelectedFinancialPrdIndex]['data'][i].lineItem) {

            if (element && element.data) {
              element.data = this.compPOVData[SelectedFinancialPrdIndex]['data'][i].data
            }
          }
        });

      } else if (this.compPOVData[SelectedFinancialPrdIndex]['data'][i]['Is_Submetric'] === 'No' && this.compPOVData[SelectedFinancialPrdIndex]['data'][i]['isSelected'] === true) {
        break;
      }
    }

    return flag === 1 ? true : false;
  }
  toggleAccordian(event) {
    var sourceNode = <HTMLElement>event.target;
    var beforeTargetNode = sourceNode.closest('tr').nextElementSibling;
    var currentNode = beforeTargetNode;
    let nextTrNodesArray = [];
    while(currentNode && currentNode.tagName === 'TR' && currentNode.classList.contains('zs-bg-surface-2')){
      nextTrNodesArray.push(currentNode);
      currentNode = currentNode.nextElementSibling;
    }
    var isOpen = !beforeTargetNode.classList.contains('zs-display-none');
    if (!isOpen) {
      sourceNode.classList.replace('zs-icon-carat-down', 'zs-icon-carat-up');
      nextTrNodesArray.forEach((targetNode)=>{
        targetNode.classList.remove('zs-display-none');
      })
    } else {
      sourceNode.classList.replace('zs-icon-carat-up', 'zs-icon-carat-down');
      nextTrNodesArray.forEach((targetNode)=>{
        targetNode.classList.add('zs-display-none');
      })
    }
  }

  compareScenarios = function () {

    let parameters = { scenariosToCompare: this.scenariosToCompare };
    this.isLoading = true;
    this.scenarioComparisonService.getScenariosFromComparisonTable(parameters).subscribe(data => {

      this.rawDataForComparison = data.rawDataForComparison;
      this.comparisonOutputGrid = data.comparisonOutputGrid;
      if(data.productList.length > 1){
        let arr1 = data.financialData;
        let arr2 = data.productList;
        arr1.push(...arr1.splice(0, arr1.length - 1));
        arr2.push(...arr2.splice(0, arr2.length - 1));
      }
      this.financialData = data.financialData;
      this.customerPOVData = data.customerPOVData;
      this.contractDetailsData = data.contractDetailsData;
      this.calenderYears.timeCategory.options = [...data.calenderYears].sort((a, b) => a - b);
      this.calenderYears.timeCategory.selected = this.calenderYears.timeCategory.options[0];
      this.selectedyear = this.calenderYears.timeCategory.options[0];
      this.renderTimePeriodDropdown();
      this.compPOVData = data.compPOVData;
      // Add breakeven data handling
      this.breakevenData = data.breakevenData;
      this.breakevenProdList = data.breakevenProdList;
      this.selectedBreakevenProductName = data.breakevenProdList[0];
      this.selectedBreakevenindex = 0;
      this.compProdList = data.competitorProdList;
      this.customerProdList = data.customerProdList;
      this.contractProdList = data.contractProdList;
      this.productList = data.productList;
      this.anchorScenarioID = data.anchorScenarioID;
      this.selectedProductName = data.productList[0];
      this.selectedCompetitorProductName = data.competitorProdList[0];
      this.selectedCustomerProductName = data.customerProdList[0];
      this.selectedContractProductName = data.contractProdList[0];
      this.selectedFinancialProductName = data.productList[0];
      this.selectedCompetitorIndex = 0;
      this.selectedCustomerindex = 0;
      this.selectedFinancialindex = 0;
      this.fillScenarioComparisonGraph();
      this.showComparisonOutput = true;
      this.tempFinancialData = JSON.parse(JSON.stringify(this.financialData));
      this.originalFinancialData = JSON.parse(JSON.stringify(this.financialData));
      this.tempCustomerPOVData = JSON.parse(JSON.stringify(this.customerPOVData));
      this.originalCustomerPOVData = JSON.parse(JSON.stringify(this.customerPOVData));
      this.tempCompPOVData = JSON.parse(JSON.stringify(this.compPOVData));
      this.originalCompPOVData = JSON.parse(JSON.stringify(this.compPOVData));
      this.pcgcData = data.pcgcData;
      this.subFinancialConfigurationDiscountSummary = {};
      this.subContractFinancialConfigurationDiscountSummary = {};
      this.subCustomerPOVConfigurationDiscountSummary = {};
      this.getParentMetrices();
      this.loadNdcData(data.ndcMap);
      this.isPCGCSelected = false;
      this.isPCGCSelectedcheck = false;
      this.isLoading = false;
    }, error => {
      this.handleError('Failed to compare scenarios.');
    });
  }
    loadNdcData(ndcMap: any) {
    this.ndcMap = ndcMap;

    // Collect unique NDC_PARENT keys across all scenarios
    const parentSet = new Set<string>();
    this.ndcMap.forEach(scenario => {
      Object.keys(scenario.ndcMapping || {}).forEach(key => parentSet.add(key));
    });
    this.ndcParentList = Array.from(parentSet);

    // Optional: auto-select first parent
    if (this.ndcParentList.length > 0) {
      this.selectedParent = this.ndcParentList[0];
    }
  }

  // Filter function for each scenario
  getFilteredProducts(scenario: any) {
    if (!this.selectedParent) return [];
    return scenario.ndcFlags.filter(
      (p: any) => p.NDC_PARENT === this.selectedParent && p.Include
    );
  }
  renderTimePeriodDropdown() {
      this.TimePerioddropdownVisible=false;
      setTimeout(() => {
        this.povCommonDdbSummary.timeCategory.selected = this.povCommonDdbSummary.timeCategory.options[0];
        this.TimePerioddropdownVisible=true;
      }, 0);
  }
  setSelectedYearVal(){
    this.calenderYears.timeCategory.selected = this.calenderYears.timeCategory.options[0];
    this.selectedyear = this.calenderYears.timeCategory.options[0];;
  }
  getParentMetrices(){
    let parentMetrics = new Set();
    for (let i = 0; i < this.originalFinancialData.length; i++) {
      for (let j = 0; j < this.originalFinancialData[i].financialData.length; j++) {
        let item = this.originalFinancialData[i].financialData[j];
        if(item.parentMetric !== null){
          parentMetrics.add(item.parentMetric);
        }
      }
    }
    for (let i = 0; i < this.originalCustomerPOVData.length; i++) {
      for (let j = 0; j < this.originalCustomerPOVData[i].data.length; j++) {
        let item = this.originalCustomerPOVData[i].data[j];
        if(item.parentMetric !== null){
          parentMetrics.add(item.parentMetric);
        }
      }
    }
    for (let i = 0; i < this.originalCompPOVData.length; i++) {
      for (let j = 0; j < this.originalCompPOVData[i].data.length; j++) {
        let item = this.originalCompPOVData[i].data[j];
        if(item.parentMetric !== null){
          parentMetrics.add(item.parentMetric);
        }
      }
    }
    this.parentMetrics = Array.from(parentMetrics);
  }
  getCompetitorindex = function (selectedCompetitorProductName) {
    this.oldCompIdx = this.selectedCompetitorIndex;
    for (var i = 0; i < this.compProdList.length; i++) {
      if (selectedCompetitorProductName == this.compProdList[i]) {
        this.selectedCompetitorIndex = i;
        break;
      }
    }
  }
  getBreakevenindex = function (selectedBreakevenProductName) {
  for (var i = 0; i < this.breakevenProdList.length; i++) {
    if (selectedBreakevenProductName == this.breakevenProdList[i]) {
      this.selectedBreakevenindex = i;
      break;
    }
  }
}

  checkCompetitorMetrics(){
    this.compPOVData[this.selectedCompetitorIndex]?.data.forEach((item, i) => {
      this.compPOVData[this.selectedCompetitorIndex].data[i].isSelected = this.compPOVData[this.oldCompIdx].data[i].isSelected;
    });
  }

  getCustomerindex = function (selectedCustomerProductName) {
    this.oldCustIdx = this.selectedCustomerindex;
    for (var i = 0; i < this.customerProdList.length; i++) {
      if (selectedCustomerProductName == this.customerProdList[i]) {
        this.selectedCustomerindex = i;
        break;
      }
    }
  }
  getContractindex = function (selectedContractProductName) {
    this.oldContractIdx = this.selectedContractIndex;
    for (var i = 0; i < this.contractProdList.length; i++) {
      if (selectedContractProductName == this.contractProdList[i]) {
        this.selectedContractIndex = i;
        break;
      }
    }
  }
  checkCustomerPCGCMetrics(){
    if(this.isPCGCSelected){
      this.customerPOVData[this.selectedCustomerindex]?.data.forEach((custMtr)=>{
        const isPresent = this.pcgcData.customer_screen.includes(custMtr.lineItem);
        isPresent ? custMtr.isSelected = true : custMtr.isSelected = false;
      })
    }else{
      this.customerPOVData[this.selectedCustomerindex]?.data.forEach((item, i) => {
        this.customerPOVData[this.selectedCustomerindex].data[i].isSelected = this.customerPOVData[this.oldCustIdx].data[i].isSelected;
      });
    }
  }
  getFinancialindex = function (selectedFinancialProductName) {
    this.oldFinIdx = this.selectedFinancialindex;
    for (var i = 0; i < this.productList.length; i++) {
      if (selectedFinancialProductName == this.productList[i]) {
        this.selectedFinancialindex = i;
        break;
      }
    }
  }

  checkFinancialPCGCMetrics(){
    if(this.isPCGCSelected){
      this.financialData[this.selectedFinancialindex]?.financialData.forEach((finMtr: any)=>{
        const isPresent = this.pcgcData.financial_screen.includes(finMtr.lineItem);
        isPresent ? finMtr.isSelected = true : finMtr.isSelected = false;
      })
    }else{
      this.financialData[this.selectedFinancialindex].financialData.forEach((item, i) => {
        this.financialData[this.selectedFinancialindex].financialData[i].isSelected = this.financialData[this.oldFinIdx].financialData[i].isSelected;
      });
    }
  }

  createOutputGridForComparison = function () {
    let parameters = { selectedProductName: this.selectedProductName, anchorScenarioID: this.anchorScenarioID, rawDataForComparison: this.rawDataForComparison, scenariosToCompare: this.scenariosToCompare }
    this.scenarioComparisonService.createOutputGridForComparison(parameters).subscribe(data => {
      this.comparisonOutputGrid = data;
      this.fillScenarioComparisonGraph();
    }, error => {
      this.handleError('Failed to create output grid for comparison.');
    });
  }

  fillScenarioComparisonGraph() {

    let tempData = this.rawDataForComparison.filter((obj) => { return obj.product_name == this.selectedProductName });
    var product = tempData[0].product_name  ;
    //fill series Data
    //get min and max contract quarters
    var minIndex = 999;
    var maxIndex = 0;
    for (var s = 0; s < tempData.length; s++) {
      var quarterDates = JSON.parse(tempData[s].QuarterInfoDates);
      for (var q = 0; q < quarterDates.length; q++) {
        if (quarterDates[q].Contract == 1) {
          if (q < minIndex) {
            minIndex = q;
          }

          let endOfContractFound = false;
          for (var j = q; j < quarterDates.length; j++) {
            if (quarterDates[j].Contract == 0) {
              endOfContractFound = true;
              if (j > maxIndex) {
                maxIndex = j - 1;
              }
              break;
            }
          }
          if (endOfContractFound == false) {
            if (quarterDates.length > maxIndex) {
              maxIndex = quarterDates.length - 1;
            }
          }

          break;
        }
      }
    }

    var seriesData = [];
    // let anchorScenarioData = tempData.filter((obj) => { return obj.scenario_id == this.anchorScenarioID })[0];
    // var anchoreSeriesData = {
    //   name: anchorScenarioData.scenario_name + " - No Deal",
    //   data: []
    // };

    // var contractExpData = JSON.parse(anchorScenarioData.contract_expectations_data);
    // var quarterDates = JSON.parse(anchorScenarioData.QuarterInfoDates);
    // var m = 0;
    // for (var q = minIndex; q <= maxIndex; q++) {
    //   if (quarterDates[q].Contract == 1) {
    //     if (tempData[0].product_name == 'Aggregated') {
    //       anchoreSeriesData.data.push(parseFloat((contractExpData.Data.noDeal.ShareData[m] * 100).toFixed(2)));
    //       m = m + 1;
    //     } else {
    //       anchoreSeriesData.data.push(parseFloat((contractExpData.noDeal.ShareData[q]).toFixed(2)));
    //     }
    //   } else {
    //     anchoreSeriesData.data.push(0);
    //   }
    // }
    // seriesData.push(anchoreSeriesData);
    for (var s = 0; s < tempData.length; s++) {

      let scenarioObject = this.scenariosToCompare.filter((obj) => { return obj.ScenarioID == tempData[s].scenario_id })[0];
      if (scenarioObject.noDeal == true) {
        var dummySeriesData = {
          name: scenarioObject.ScenarioName + " - noDeal",
          data: []
        };
        if (!tempData[s]?.contract_expectations_data || tempData[s].contract_expectations_data === 'undefined') {
          break;
        }
        var contractExpData = JSON.parse(tempData[s].contract_expectations_data);
        var quarterDates = JSON.parse(tempData[s].QuarterInfoDates);
        let parentNDCNames = Object.keys(JSON.parse(tempData[s]?.ndcMap ?? "[]")?.ndcMapping ?? {});
        var m = 0;
        for (var q = minIndex; q <= maxIndex; q++) {
          if (quarterDates[q].Contract == 1) {
            if (tempData[0].product_name === 'Aggregated') {
              dummySeriesData.data.push(parseFloat((contractExpData?.Data?.noDeal?.ShareData[m] * 100).toFixed(2)));
              m = m + 1;
            }else if(parentNDCNames.includes(tempData[s].product_name)){
              dummySeriesData.data.push(parseFloat((contractExpData?.Data?.noDeal?.ShareData[q - minIndex] * 100)?.toFixed(2)));
            } else {
              dummySeriesData.data.push(parseFloat((contractExpData?.noDeal?.ShareData[q]).toFixed(2)));
            }
          } else {
            dummySeriesData.data.push(0);
          }
        }
        seriesData.push(dummySeriesData);
      }
    }
    for (var s = 0; s < tempData.length; s++) {

      let scenarioObject = this.scenariosToCompare.filter((obj) => { return obj.ScenarioID == tempData[s].scenario_id })[0];
      if (scenarioObject.deal == true) {
        var dummySeriesData = {
          name: scenarioObject.ScenarioName + " - Deal",
          data: []
        };
        if (!tempData[s]?.contract_expectations_data || tempData[s].contract_expectations_data === 'undefined') {
          break;
        }
        var contractExpData = JSON.parse(tempData[s].contract_expectations_data);
        var quarterDates = JSON.parse(tempData[s].QuarterInfoDates);
        let parentNDCNames = Object.keys(JSON.parse(tempData[s]?.ndcMap ?? "[]")?.ndcMapping ?? {});
        var m = 0;
        for (var q = minIndex; q <= maxIndex; q++) {
          if (quarterDates[q].Contract == 1) {
            if (tempData[0].product_name == 'Aggregated') {
              dummySeriesData.data.push(parseFloat((contractExpData?.Data?.deal?.ShareData[m] * 100).toFixed(2)));
              m = m + 1;
            }else if(parentNDCNames.includes(tempData[s].product_name)){
              dummySeriesData.data.push(parseFloat((contractExpData?.Data?.deal?.ShareData[q - minIndex] * 100)?.toFixed(2)));
              m = m + 1;
            } else {
              dummySeriesData.data.push(parseFloat(((contractExpData.deal.ShareData[q] ?? 0)).toFixed(2)));
            }
          } else {
            dummySeriesData.data.push(0);
          }
        }
        seriesData.push(dummySeriesData);
      }
    }



    var xAxisCategories = [];
    var quarterDates = JSON.parse(tempData[0].QuarterInfoDates);
    for (var x = minIndex; x <= maxIndex; x++) {
      xAxisCategories.push(quarterDates[x].qtr);

    }

    this.chartOptions = {

      title: {
        text: product
      },
      credits: {
        enabled: false
      },

      yAxis: {
        title: {
          text: '% Market Share'
        }
      },
      xAxis: {
        categories: xAxisCategories,
        labels: {
          rotation: -45,
        },
        plotLines: [
        ],
      },
      legend: {
        enabled: true,
      },

      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
        }
      },

      series: seriesData,

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }

    };
    setTimeout(() => {
      Highcharts.chart(this.chartContainer.nativeElement, this.chartOptions);
    }, 1)
  }

  // newly updated
  //     fillScenarioComparisonGraph() {
  //     let tempData = this.rawDataForComparison.filter(obj => obj.product_name === this.selectedProductName);
  //     if (tempData.length === 0) {
  //         console.warn("No data found for the selected product.");
  //         return;
  //     }

  //     const product = tempData[0]?.product_family;

  //     // Initialize min and max indices for contract quarters
  //     let minIndex = 999, maxIndex = 0;

  //     // Identify min and max indices for contract periods
  //     tempData.forEach((item) => {
  //         const quarterDates = JSON.parse(item.QuarterInfoDates);
  //         quarterDates.forEach((quarter, q) => {
  //             if (quarter.Contract === 1) {
  //                 minIndex = Math.min(minIndex, q);
  //                 let endOfContractFound = false;

  //                 for (let j = q; j < quarterDates.length; j++) {
  //                     if (quarterDates[j].Contract === 0) {
  //                         endOfContractFound = true;
  //                         maxIndex = Math.max(maxIndex, j - 1);
  //                         break;
  //                     }
  //                 }
  //                 if (!endOfContractFound) maxIndex = Math.max(maxIndex, quarterDates.length - 1);
  //             }
  //         });
  //     });

  //     const seriesData = [];

  //     // Iterate and filter for No Deal and Deal Scenarios separately
  //     tempData.forEach((item) => {
  //         let contractExpData = JSON.parse(item.contract_expectations_data);
  //         const quarterDates = JSON.parse(item.QuarterInfoDates);

  //         // Check if the scenario is a "No Deal" or "Deal"
  //         if (!item.deal) {
  //             const noDealSeries = {
  //                 name: `${item.scenario_name} - No Deal`,
  //                 data: []
  //             };
  //             let m = 0;
  //             for (let q = minIndex; q <= maxIndex; q++) {
  //                 noDealSeries.data.push(quarterDates[q].Contract === 1
  //                     ? parseFloat((item.product_name === 'Aggregated'
  //                         ? contractExpData.Data.noDeal.ShareData[m++] * 100
  //                         : contractExpData.noDeal.ShareData[q]).toFixed(2))
  //                     : 0);
  //             }
  //             seriesData.push(noDealSeries);
  //         }

  //         if (item.deal) {
  //             const dealSeries = {
  //                 name: `${item.scenario_name} - Deal`,
  //                 data: []
  //             };
  //             let m = 0;
  //             for (let q = minIndex; q <= maxIndex; q++) {
  //                 dealSeries.data.push(quarterDates[q].Contract === 1
  //                     ? parseFloat((item.product_name === 'Aggregated'
  //                         ? contractExpData.Data.deal.ShareData[m++] * 100
  //                         : contractExpData.deal.ShareData[q]).toFixed(2))
  //                     : 0);
  //             }
  //             seriesData.push(dealSeries);
  //         }
  //     });

  //     // X-axis categories
  //     const xAxisCategories = [];
  //     const quarterDates = JSON.parse(tempData[0].QuarterInfoDates);
  //     for (let x = minIndex; x <= maxIndex; x++) {
  //         xAxisCategories.push(quarterDates[x].qtr);
  //     }

  //     this.chartOptions = {
  //         title: { text: product },
  //         credits: { enabled: false },
  //         yAxis: { title: { text: '% Market Share' }},
  //         xAxis: {
  //             categories: xAxisCategories,
  //             labels: { rotation: -45 }
  //         },
  //         legend: { enabled: true },
  //         plotOptions: {
  //             series: {
  //                 label: { connectorAllowed: false }
  //             }
  //         },
  //         series: seriesData,
  //         responsive: {
  //             rules: [{
  //                 condition: { maxWidth: 500 },
  //                 chartOptions: {
  //                     legend: { layout: 'horizontal', align: 'center', verticalAlign: 'bottom' }
  //                 }
  //             }]
  //         }
  //     };

  //     // Render the chart
  //     setTimeout(() => {
  //         Highcharts.chart(this.chartContainer.nativeElement, this.chartOptions);
  //     }, 1);
  // }



  disableCompareScenariosButton = function () {
    if (this.scenariosToCompare.length === 0) {
      return true; // Disable the button if there are no scenarios
    }
    let scenariosCheckedForComparisonlocal = 0;// Tracks deal and nodeal checkboxes
    if(this.showAnchor){
      let anchorScenario = 0; // Tracks anchor checkboxes
      for (let i = 0; i < this.scenariosToCompare.length; ++i) {
        if (this.scenariosToCompare[i].deal) {
          scenariosCheckedForComparisonlocal += 1; // Count deal or nodeal checkboxes
        }
        if (this.scenariosToCompare[i].anchor) {
          anchorScenario += 1; // Count anchor checkboxes
        }
      }
      // Disable the button if no scenarios are selected, or fewer than 5 deals/nodeals are checked
      if (scenariosCheckedForComparisonlocal === 0 || anchorScenario == 0) {
        this.scenariosCheckedForComparison = scenariosCheckedForComparisonlocal;
        return true;
      }
    }else{

      for (let i = 0; i < this.scenariosToCompare.length; ++i) {
        if (this.scenariosToCompare[i].deal) {
          scenariosCheckedForComparisonlocal += 1; // Count deal or nodeal checkboxes
        }
        if (this.scenariosToCompare[i].noDeal) {
          scenariosCheckedForComparisonlocal += 1;
        }
      }
      // Disable the button if no scenarios are selected, or fewer than 5 deals/nodeals are checked
      if (scenariosCheckedForComparisonlocal === 0 || scenariosCheckedForComparisonlocal > this.maxCheckedLimit || scenariosCheckedForComparisonlocal < 2) {
        this.scenariosCheckedForComparison = scenariosCheckedForComparisonlocal;
        return true;
      }
      this.scenariosCheckedForComparison = scenariosCheckedForComparisonlocal;
    }
    return false; // Enable the button when 5 or more deals/nodeals are checked and an anchor is selected
  }


  openScenario(scenarioId) {
    this.appService.clearDataOnClientSession();
    this.router.navigate(['/ubc/scenario', btoa(scenarioId)]);
  }

  copyToExcel(gridType, shouldFetchStringText) {
    this.gridType = gridType;
    if (window.clipboardData) {
      var string = this.getCopiedData();
      window.clipboardData.setData('Text', string);
    } else {
      this.customCopyFlag = shouldFetchStringText;
      document.execCommand('copy');
    }
  }

  getCopiedData(): string {
    switch (this.gridType) {
      case 'scenarioComparison':
        return this.getScenarioComparisonGrid();
        break;
      case 'scenarioComparisonContractFinancials':
        return this.getScenarioComparisonGridContractFinancials();
        break;
      case 'scenarioComparisonContractDetails':
        return this.getScenarioComparisonGridContractDetails();
        break;
      case 'scenarioComparisonCustomerPOV':
        return this.getScenarioComparisonGridCustomerPOV();
        break;
      case 'scenarioComparisonCompetitorPOV':
        return this.getScenarioComparisonGridCompetitorPOV();
        break;
      case 'scenarioComparisonBreakevenMetrics':
      return this.getScenarioComparisonGridBreakevenMetrics();
      break;
      default:
    }
  }

  getScenarioComparisonGrid = function () {
    var string = "";
    string += "Scenario Name\tTotal Scenario Net Sales(in $)\tDelta Scenario Net Sales (Compared to Anchor)\tROC (Compared to respective No Deal)\tExit Share %\tDiscretionary Rebate %\tTotal Rebate %\n";
    for (var idx = 0; idx < this.comparisonOutputGrid.length; idx++) {
      if (idx === 0) {
        string += this.comparisonOutputGrid[idx].ScenarioName + "- No Deal\t";
      }
      else {
        string += this.comparisonOutputGrid[idx].ScenarioName + "- Deal\t";
      }
      string += this.comparisonOutputGrid[idx].NetSales + "\t" + this.comparisonOutputGrid[idx].DeltaNetSales + "\t" + this.comparisonOutputGrid[idx].ROC + "\t " + this.comparisonOutputGrid[idx].ExitShare + "%\t" + this.comparisonOutputGrid[idx].DiscretionaryRebates + "%\t" + this.comparisonOutputGrid[idx].TotalRebate + "%\n";
    }
    return string;
  }

  getScale(multiplier: number): string {
    if (multiplier === 1000) return 'Thousands';
    if (multiplier === 1000000) return 'Millions';
    return 'Actuals';
  }
  getScenarioComparisonGridContractFinancials = function () {
    var string = "";
    const decimalPlaces= +this.contractDecimalFormat.split('-')[1];
    const scale = this.getScale(this.selectedContractFinancialMultiplier);
    string += "Metrics"+"("+scale+")\t";
    for (var i = 0; i < this.comparisonOutputGrid.length; i++) {
      string += this.comparisonOutputGrid[i].scenario_name + "\t";
    }
    string += "\n";
    for (var i = 0; i < this.financialData[this.selectedFinancialindex].financialData.length; i++) {
      if (this.financialData[this.selectedFinancialindex].financialData[i].isSelected === true){
        string += this.financialData[this.selectedFinancialindex].financialData[i].Item_Text + "\t";
        if(this.povCommonDdbSummary.timeCategory.selected === 'Total Contract Period'){
          for (var j = 0; j < this.financialData[this.selectedFinancialindex].financialData[i].data.length; j++){
            const value = this.financialData[this.selectedFinancialindex].financialData[i].data[j];
            // Check if value is "-" or not a number
            string += (value === "-" || value * 1 != value * 1) ? value + "\t" : (value / this.selectedContractFinancialMultiplier).toFixed(decimalPlaces) + "\t";
          }
        }else{
          const yearlyItem = this.financialData[this.selectedFinancialindex].financialData[i].yearlyDataView.find(item => item.year === +this.selectedyear);
          const rowData = yearlyItem?.data ?? [];
          for (let j = 0; j < rowData.length; j++) {
            // Check if value is "-" or not a number
            string += (rowData[j] === "-" || rowData[j] * 1 != rowData[j] * 1) 
              ? rowData[j] + "\t" 
              : (rowData[j] / this.selectedContractFinancialMultiplier).toFixed(decimalPlaces) + "\t";
          }
        }
        
        string += "\n";
      }
    }
    return string;
  }

  getScenarioComparisonGridCustomerPOV = function () {
    var string = "";
    const decimalPlaces = +this.customerDecimalFormat.split('-')[1];
    const scale = this.getScale(this.selectedCusPovMultiplier);
    string += "Metrics"+"("+scale+")\t";
    for (var i = 0; i < this.comparisonOutputGrid.length; i++) {
      string += this.comparisonOutputGrid[i].scenario_name + "\t";
    }
    string += "\n";
    for (var i = 0; i < this.customerPOVData[this.selectedCustomerindex].data.length; i++) {
      if (this.customerPOVData[this.selectedCustomerindex].data[i].isSelected === true){
        string += this.customerPOVData[this.selectedCustomerindex].data[i].Item_Text + "\t";
        if(this.povCommonDdbSummary.timeCategory.selected === 'Total Contract Period'){
          for (var j = 0; j < this.customerPOVData[this.selectedCustomerindex].data[i].data.length; j++){
             const cell = this.customerPOVData[this.selectedCustomerindex].data[i].data[j];
             string += (cell === "-" || isNaN(cell)) ? cell + "\t" : (cell / this.selectedCusPovMultiplier).toFixed(decimalPlaces) + "\t";
          }
        }else{
          const yearlyItem = this.customerPOVData[this.selectedCustomerindex].data[i].yearlyDataView.find(item => item.year === +this.selectedyear);
          const rowData = yearlyItem?.data ?? [];
          for (let j = 0; j < rowData.length; j++) {
            const cell = rowData[j];
            string += (cell === "-" || isNaN(cell)) 
              ? cell + "\t" 
              : (cell / this.selectedCusPovMultiplier).toFixed(decimalPlaces) + "\t";
          }
        }
        string += "\n";
      }
    }
    return string;
  }
  getScenarioComparisonGridContractDetails = function () {
    var string = "";
    const decimalPlaces= +this.contractDetailsDecimalFormat.split('-')[1];
    const scale = this.getScale(this.selectedContractDetailsMultiplier);
    string += "Metrics"+"("+scale+")\t";
    for (var i = 0; i < this.comparisonOutputGrid.length; i++) {
      string += this.comparisonOutputGrid[i].scenario_name + "\t";
    }
    string += "\n";
    for (var i = 0; i < this.contractDetailsData[this.selectedContractIndex].data.length; i++) {
      if (this.contractDetailsData[this.selectedContractIndex].data[i].isSelected === true){
        string += this.contractDetailsData[this.selectedContractIndex].data[i].Item_Text + "\t";
        for (var j = 0; j < this.contractDetailsData[this.selectedContractIndex].data[i].data.length; j++){
            const cell = this.contractDetailsData[this.selectedContractIndex].data[i].data[j];
            string += isNaN(cell) ? cell + "\t" : (cell / this.selectedContractDetailsMultiplier).toFixed(decimalPlaces) + "\t";
        }
        string += "\n";
      }
    }
    return string;
  }
  getScenarioComparisonGridCompetitorPOV = function () {
    var string = "";
    const decimalPlaces= +this.competitorDecimalFormat.split('-')[1];
    const scale = this.getScale(this.selectedMultiplier);
    string += "Metrics"+"("+scale+")\t";
    for (var i = 0; i < this.comparisonOutputGrid.length; i++) {
      string += this.comparisonOutputGrid[i].scenario_name + "\t";
    }
    string += "\n";
    for (var i = 0; i < this.compPOVData[this.selectedCompetitorIndex].data.length; i++) {
      if (this.compPOVData[this.selectedCompetitorIndex].data[i].isSelected === true){
        string += this.compPOVData[this.selectedCompetitorIndex].data[i].Item_Text + "\t";
        if(this.povCommonDdbSummary.timeCategory.selected === 'Total Contract Period'){
          for (var j = 0; j < this.compPOVData[this.selectedCompetitorIndex].data[i].data.length; j++){
              const cell = this.compPOVData[this.selectedCompetitorIndex].data[i].data[j];
              string += (cell === "-" || isNaN(cell)) ? cell + "\t" : (cell / this.selectedMultiplier).toFixed(decimalPlaces) + "\t";
          }
        }else{
          const yearlyItem = this.compPOVData[this.selectedCompetitorIndex].data[i].yearlyDataView.find(item => item.year === +this.selectedyear);
          const rowData = yearlyItem?.data ?? [];
          for (let j = 0; j < rowData.length; j++) {
          const cell = rowData[j];
          string += (cell === "-" || isNaN(cell)) ? cell + "\t" : (cell / this.selectedMultiplier).toFixed(decimalPlaces) + "\t";
          }
        }
        string += "\n";
      }
    }
    return string;
  }
 getScenarioComparisonGridBreakevenMetrics = function () {
  var string = "";
  string += "Metrics\t";
  for (var i = 0; i < this.comparisonOutputGrid.length; i++) {
    string += this.comparisonOutputGrid[i].scenario_name + "\t";
  }
  string += "\n";
  
  for (var i = 0; i < this.breakevenData[this.selectedBreakevenindex]?.data?.length; i++) {
    const row = this.breakevenData[this.selectedBreakevenindex].data[i];
    if (row.isSectionHeader) {
      string += row.Item_Text + "\n";
    } else if (row.isSelected === true) {
      string += row.Item_Text + "\t";
      for (var j = 0; j < row.data.length; j++) {
        string += row.data[j] + "\t";
      }
      string += "\n";
    }
  }
  return string;
}

  ngOnDestroy() {
    // Clean up timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
}
